import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchAgentProfileLists(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('customer/agent/profile-change/list', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
